import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import animationData from "../../../data";

const CompatioLoader = ({ width = "300px", height = "300px", showLoader = true, viewHeight = 10,}) => {
  const container = useRef(null);
  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData,
    });
  }, [showLoader]);

  return (
    <div
      className={`d-flex container w-${viewHeight}  justify-content-center align-items-center`}
      style={{ width: width, height: height }}
      ref={container}
    ></div>
  );
};

export default CompatioLoader;
